import { TFunction } from 'i18next'

import { InvoiceDocumentType } from '../enums/invoiceDocumentType'

export const getDocumentDraftDeletionNotification = (documentType: InvoiceDocumentType, t: TFunction) => {
  switch (documentType) {
    case InvoiceDocumentType.Quote:
      return t('external_invoices.quote_draft_deleted')
    case InvoiceDocumentType.Invoice:
    default:
      return t('external_invoices.invoice_draft_deleted')
  }
}
